import { karlaFont } from '../fonts/karla/karla.font.js';
import { athleticsFont } from '../fonts/athletics/athletics.font.js';

export const fonts = {
    '@font-face': [karlaFont.regular, karlaFont.bold, karlaFont.boldItalic, karlaFont.italic, athleticsFont.bold],
};

export const fontsString = [
    karlaFont.regular,
    karlaFont.bold,
    karlaFont.boldItalic,
    karlaFont.italic,
    athleticsFont.bold,
]
    .map((font) => {
        return `@font-face {
        font-family: ${font.fontFamily};
        font-style: ${font.fontStyle};
        font-weight: ${font.fontWeight};
        font-display: ${font.fontDisplay};
        src: ${font.src};
        unicode-range: ${font.unicodeRange};
    }`;
    })
    .join('\n\n');
